// extracted by mini-css-extract-plugin
module.exports = {"tabs":"DocumentTabs_tabs__2bUOL"};